<template>
<div class="k__preview-video-wrapper">
  <van-popup
    :show="show"
    position="center"
    closeable
    close-on-click-overlay
    @click-close-icon="handleClose"
    @click-overlay="handleOverlayClick"
  >
    <van-swipe class="my-swipe" :autoplay="0" indicator-color="white" :initial-swipe="curIdx">
      <van-swipe-item v-for="(src, idx) in srcs" :key="idx">
        <div class="image-wrapper">
          <div v-if="/\.mp4|\.mpd/.test(src)" class="image-video" style="text-align: center;">
            <KVideoPlayer
              :class="useIsMobile().value ? 'preview-video' : 'pc__preview-video'"
              :src="src"
              ref="KVideoPlayerRef"
            />
          </div>

          <div v-else class="preview-image">
            <img :class="useIsMobile().value ? 'preview-video' : 'pc__preview-video'" v-lazy="$cvWebpFn(src)" alt="">
          </div>

          <div class="switch" v-if="!useIsMobile().value">
            <div class="switch-item l-switch"><van-icon name="arrow-left" size="30px" @click="handleSwitchClick(-1)"/></div>
            <div class="switch-item r-switch"><van-icon name="arrow" size="30px" @click="handleSwitchClick(1)" /></div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </van-popup>
</div>
</template>

<script setup lang="ts">
const props = defineProps<{
  show: boolean,
  mediaList: IReview.IMediaList[],
  curIdx: number
}>()
const emits = defineEmits<{
  (evnet: 'update:show', show: boolean): void,
  (event: 'update:curIdx', e: number): void
}>()

const srcs = computed<string[]>(() => props.mediaList.map((c: IReview.IMediaList) => c.dashMediaContents || c.mediaContents))
const KVideoPlayerRef = ref()
const handleClose = () => {
  KVideoPlayerRef.value?.length && KVideoPlayerRef.value[0].pause()
  emits('update:show', false)
}
const handleOverlayClick = () => {
  handleClose()
}

const handleSwitchClick = (e: number) => {
  const cur = props.curIdx + e

  emits(
    'update:curIdx', 
    cur < 0
      ? 0
      : cur >= srcs.value.length
        ? srcs.value.length - 1
        : cur
    )
}
</script>

<style lang="scss" scoped>
.k__preview-video-wrapper::v-deep(.van-popup){
  background-color: transparent;
  width: 100vw;
  max-width: 100vw;
  padding-top: 110px;
  top: calc(50% - 110px);
}

.preview-video{
  width: 100%;
  height: 70vh;
  object-fit: contain;
}
.preview-image{
  text-align: center;
}
.pc__preview-video{
  width: 80vw;
  height: 70vh;
  object-fit: contain;
  margin: 0 auto;
}
.image-wrapper{
  position: relative;
  .image-video{
    width: 100vw;
    height: 60vh;
  }
  .switch{
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 100px;
    .switch-item{
      height: 100px;
      width: 100px;
      border-radius: 50%;
      @include center();
      background-color: rgba($color: #fff, $alpha: 0.6);
    }
  }
}
</style>